import I3WorkOrderState = ToroEnums.I3WorkOrderState;

import * as moment from 'moment';
import { ToroEnums } from '../../../common/enumerations/toro.enums';

export class I3OpenWorkOrders {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.openWorkOrderModelList) { this.openWorkOrderModelList = json.openWorkOrderModelList.map(wo => new I3OpenWorkOrder(wo)); }
        }
    }

    openWorkOrderModelList: I3OpenWorkOrder[] = [];
}

export class I3OpenWorkOrder {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.dueDate) this.dueDate = moment.utc(json.dueDate).toDate();
        }
    }

    locationId: number;
    assetId: number;
    assetCode: string;
    model: string;
    description: string;
    workOrderId: number
    workOrderNumber: number;
    workOrderStateId: I3WorkOrderState;
    isPriority: boolean;
    dueDate: Date;
    estimatedTime: number;
    assignedWorkOrderLabors: string;
    taskCount: number;
    completedCount: number;

}

export class I3AssetWorkOrders {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.workOrders) this.workOrders =  json.workOrders.map(t => new I3OpenWorkOrder(t));
        }
    }

    assetId: number;
    workOrders: I3OpenWorkOrder[] = [];
}
